import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Table } from 'semantic-ui-react';
import { get, map } from 'lodash';
import moment from 'moment';

import client from '../../apollo';
import guaranteePurchaseAuditsQuery from '../../graphql/guaranteePurchaseAuditsQuery';
import AuditSearch from './AuditSearch';

class GuaranteePurchaseAudit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guaranteePurchaseAudits: [],
      startDate: null,
      endDate: null,
    };
  }

  componentDidMount() {
    this.fetchGuaranteePurchaseAudits();
  }

  fetchGuaranteePurchaseAudits = () => {
    const { guaranteePurchase } = this.props;
    const { startDate, endDate } = this.state;
    const { id } = guaranteePurchase;
    client
      .query({
        query: guaranteePurchaseAuditsQuery,
        variables: {
          guaranteePurchaseId: parseInt(id, 10),
          startDate,
          endDate,
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        const guaranteePurchaseAudits = get(data, 'guaranteePurchaseAudits');
        this.setState({
          guaranteePurchaseAudits,
        });
      });
  };

  render() {
    const { isAuditModalOpen, onCloseHandler } = this.props;

    const { guaranteePurchaseAudits, startDate, endDate } = this.state;
    const onDateChangeHandler = (field, date) => {
      this.setState({
        [field]: moment(new Date(date), 'YYYY-MM-DD'),
      });
    };

    const clearDates = () => {
      this.setState({ startDate: null, endDate: null });
    };

    return (
      <Modal
        open={isAuditModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Status History - Guarantee Purchases</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            <div size='big'>
              <AuditSearch
                onDateChangeHandler={onDateChangeHandler}
                clearDates={clearDates}
                startDate={startDate}
                endDate={endDate}
                onSearchHandler={this.fetchGuaranteePurchaseAudits}
              />
              {map(guaranteePurchaseAudits, audit => (
                <Table celled padded size='big' style={{ margin: '0 0' }} key={audit.id}>
                  <Table.Body>
                    <Table.Row
                      style={{ backgroundColor: 'LightGray' }}
                    >
                      <Table.Cell width={12}>
                        {audit.event === 'update'
                          && `${
                            audit.versionAuthor
                          } updated the Guarantee Purchase - ${
                            audit.itemType
                          } details`}
                        {audit.event === 'create'
                          && `${
                            audit.versionAuthor
                          } created the Guarantee Purchase - ${audit.itemType}`}
                        {audit.event === 'destroy'
                          && `${
                            audit.versionAuthor
                          } Destroyed Guarantee Purchase - ${audit.itemType}`}
                      </Table.Cell>
                      <Table.Cell>{audit.timeStamp}</Table.Cell>
                    </Table.Row>
                    {map(JSON.parse(audit.changeset), (change, key) => {
                      if (key !== 'updated_at'
                          && audit.event === 'update'
                          && change[1] !== null
                          && change[1] !== '') {
                        return (
                          <Table.Row key={key}>
                            <Table.Cell>
                              <span>
                                set{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {key}{' '}
                                </span>
                                from{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {' '}
                                  {change[0] || 'nil'}{' '}
                                </span>
                                to{' '}
                                <span style={{ fontWeight: 'bold' }}>
                                  {change[1]}{' '}
                                </span>
                              </span>
                            </Table.Cell>
                          </Table.Row>
                        );
                      }
                      return null;
                    })}
                  </Table.Body>
                </Table>
              ))}
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

GuaranteePurchaseAudit.propTypes = {
  guaranteePurchase: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isAuditModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
};

export default GuaranteePurchaseAudit;
